module.exports = __webpack_public_path__ + "img/3.171f6066.png";